module.exports = {
  "defaultLanguage": "en-US",
  "languages": [
    {
      "code": "en-US",
      "name": "English",
      "icon": null
    }
  ]
}